@if (state === 'loading') {
  <app-spinner></app-spinner>
}
@if (state === 'offline') {
  <tyt-offline message="Internet connectivity is required to change your notification settings."></tyt-offline>
}
@if (state === 'ready') {

  <div class="alert alert-info with-icon">
    <mat-icon>devices</mat-icon>
    <div>
      <strong>Looking for push notification settings for TYT for iOS / Android?</strong><br />
      Open the TYT app on your phone, tap the Settings menu in the upper right and choose Communication Preferences.
    </div>
  </div>

  <mat-tab-group #tabs mat-stretch-tabs="false">
    <mat-tab id="in_app" label="On TYT.com">
      <h2>Notifications on TYT.com</h2>
      <p>Adjusting these toggles will control what notifications appear in the notification center in the top right. You can access them by clicking on your profile photo.</p>
      <tyt-notifications-category-settings
        category="in_app"
        [prefs]="prefs"
        [prefValues]="prefValues"
      ></tyt-notifications-category-settings>
      <ng-container *ngTemplateOutlet="submit" />
    </mat-tab>
    @if (isPushSupported) {
      <mat-tab id="push" label="Push">
        <h2>Push Notifications</h2>
        <p>
          @if (pushType === 'web') {
            Receive TYT.com notifications on your mobile phone/desktop computer
            via your web browser.
          }
          @if (pushType === 'native') {
            Receive TYT.com notifications on your mobile phone/tablet.
          }
          Push notifications for this {{pushDevice}} are currently
          @if (isPushEnabled) {
            <strong>enabled.</strong>
          }
          @if (!isPushEnabled) {
            <strong>disabled.</strong>
          }
        </p>
        @if (!isPushEnabled) {
          <a mat-button (click)="enablePushNotifications()">
            <mat-icon>notifications</mat-icon>
            Enable Push Notifications for this {{pushDevice}}
          </a>
        }
        @if (isPushEnabled) {
          <a mat-button (click)="disablePushNotifications()">
            <mat-icon>notifications</mat-icon>
            Disable Push Notifications for this {{pushDevice}}
          </a>
        }

        <ng-container *ngTemplateOutlet="submit" />
      </mat-tab>
    }
    <mat-tab id="email" label="Email">
      <h2>Notifications Delivered to Your Email</h2>
      <p>You will receive your chosen notifications at the address associated with your TYT account,
        which is <em class="email">{{ user.email }}</em></p>
      <tyt-notifications-category-settings
        category="email"
        [prefs]="prefs"
        [prefValues]="prefValues"
      ></tyt-notifications-category-settings>
      <ng-container *ngTemplateOutlet="submit" />
    </mat-tab>
  </mat-tab-group>
  <ng-template #submit>
    <div class="buttons">
      <button mat-raised-button color="primary" [disabled]="loading" type="button" color="primary" (click)="saveChanges()">
        @if (loading) {
          <app-spinner class="line" ></app-spinner>
        } @else {
          <span>Save Changes</span>
        }
      </button>
    </div>
  </ng-template>
}